/**
 *
 */
import ReglRendererService from './regl';

export { ReglRendererService };
